import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";

function CreaGeneralidades(props) {
  const cookies = new Cookies();

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [postPerfil, setPostPerfil] = useState([]);

  const [archivos, setArchivos] = useState(null);
  const subirArchivos = (e) => {
    setArchivos(e);
  };
  const insertarArchivos = async () => {
    const f = new FormData();
    for (let index = 0; index < archivos.length; index++) {
      f.append("files", archivos[index]);
    }
    await axios
      .post(
        "https://suadesarrollo.azurewebsites.net/api/CargaMasivosGeneralidades?SolicitudId=" +
          props.idSolicitud +
          "&Perfil=" +
          postPerfil,
        f,
      )

      .then((response) => {
        console.log(response.data);
        alert("Cargue con exito!");
        console.log(postPerfil);
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Adjuntar Documento
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Declaracion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Sube el documento
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <div className="col-sm-12">
                      <select
                        className="btn btn-secondary btn-user btn-block"
                        onChange={(e) => setPostPerfil(e.target.value)}
                      >
                        <option value="">Seleccione </option>
                        <option value="Medico General">Medico General </option>
                        <option value="Aux Enfermeria">Aux Enfermeria </option>
                        <option value="Profesional Enfermeria">
                          Profesional Enfermeria{" "}
                        </option>
                        <option value="Medico Especialista">
                          Medico Especialista{" "}
                        </option>
                      </select>
                    </div>
                    <hr />
                    <div className="text-center">
                      <input
                        type="file"
                        name="files"
                        accept=".csv"
                        multiple
                        onChange={(e) => subirArchivos(e.target.files)}
                      />
                    </div>
                    <hr />
                    <button
                      className="btn btn-primary"
                      onClick={() => insertarArchivos()}
                    >
                      insertar archivos
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaGeneralidades;
